import { FormFieldTypes } from "../../../../data/formFieldType";

export const CertificationRenewalData = {
  name: "CertificationRenewalDetails",
  initialState: {
    remarks: "",
    terminationType: "Terminate Immediately",
  },
  formFields: [
    {
      id: "remarks",
      lable: "Remarks",
      Field_Name: "Remarks",
      fieldType: FormFieldTypes.TEXTAREA,
      dataField: "remarks",
      fieldSetting: {
        placeholder: "Please add remarks for this certification",
        allowSpace: true,
        rows: 4,
      },
      style: {
        containerCss: "col-12 mb-3",
      },
    },
    {
      id: "terminationType",
      lable: "Termination Type Dropdown",
      Field_Name: "Termination Type Dropdown",
      fieldType: FormFieldTypes.SELECT,
      dataField: "terminationType",
      fieldSetting: {
        placeholder: "Select Termination Type",
        options: [
          { value: "Terminate Immediately", label: "Terminate Immediately" },
          { value: "Terminate on Certificate End Date", label: "Terminate on Certificate End Date" },
        ],
      },
      style: {
        containerCss: "col-12 mb-3",
      },
    },
  ],
};
